<template>
  <form @submit.prevent="submit">
    <div class="field">
      <label>Nombre *</label>
      <InputText v-model="form.name" class="w-full" required />
    </div>
    <div class="field">
      <label>Email *</label>
      <InputText v-model="form.email" type="email" class="w-full" required />
    </div>
    <div class="field">
      <label>Tipo de entidad por defecto</label>
      <Dropdown
        v-model="form.default_company_type_code"
        :options="companyTypes"
        optionLabel="name"
        optionValue="code"
        placeholder="Sin configuración"
        showClear
        class="w-full"
      />
    </div>
    <div class="field">
      <label>Marco normativo por defecto</label>
      <Dropdown
        v-model="form.default_accounting_framework_code"
        :options="accountingFrameworks"
        optionLabel="name"
        optionValue="code"
        placeholder="Sin configuración"
        showClear
        class="w-full"
      />
    </div>
    <div class="actions">
      <Button label="Cancelar" severity="secondary" type="button" @click="$emit('cancel')" />
      <Button label="Guardar" type="submit" :loading="loading" />
    </div>
  </form>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import { tenantsService } from '../../services/tenants';
import api from '../../services/api';

const emit = defineEmits(['saved', 'cancel']);
const props = defineProps({
  tenant: { type: Object, required: true },
});
const form = ref({
  name: '',
  email: '',
  default_company_type_code: null,
  default_accounting_framework_code: null,
});
const loading = ref(false);
const companyTypes = ref([]);
const accountingFrameworks = ref([]);

onMounted(async () => {
  try {
    const [companyTypesRes, frameworksRes] = await Promise.all([
      api.get('/catalogs/company-types'),
      api.get('/catalogs/accounting-frameworks'),
    ]);
    companyTypes.value = companyTypesRes.data;
    accountingFrameworks.value = frameworksRes.data;
  } catch (e) {
    console.error(e);
  }
  form.value = {
    name: props.tenant?.name || '',
    email: props.tenant?.email || '',
    default_company_type_code: props.tenant?.default_company_type_code || null,
    default_accounting_framework_code: props.tenant?.default_accounting_framework_code || null,
  };
});

const submit = async () => {
  loading.value = true;
  try {
    await tenantsService.updateTenant(props.tenant.id, form.value);
    emit('saved');
  } catch (e) {
    console.error(e);
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.field { margin-bottom: 1rem; }
.field label { display: block; margin-bottom: 0.4rem; font-weight: 500; }
.w-full { width: 100%; }
.actions { display: flex; justify-content: flex-end; gap: 0.5rem; margin-top: 1rem; }
</style>
